import { FC } from "react";
import { C } from "../constants";
import { useAuth } from "../auth/AuthProvider";
import { ALLOWED_DOMAINS_LABEL } from "../auth/firebase";

// Google "G" mark (inline SVG so no external asset / CSP issue).
const GoogleG: FC = () => (
  <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

export const LoginScreen: FC = () => {
  const { signIn, error } = useAuth();

  return (
    <div style={{
      height: "100vh", width: "100vw", display: "flex", alignItems: "center", justifyContent: "center",
      background: `radial-gradient(1200px 600px at 50% -10%, ${C.accentLight}, transparent 60%), ${C.bg}`,
    }}>
      <div style={{
        width: 380, maxWidth: "90vw", padding: "40px 36px", borderRadius: 16,
        background: C.panel, border: `1px solid ${C.border}`,
        boxShadow: "0 24px 60px rgba(0,0,0,0.45)", textAlign: "center",
      }}>
        <div style={{
          width: 52, height: 52, margin: "0 auto 18px", borderRadius: 14,
          background: `linear-gradient(135deg, ${C.accent}, #1a6e8a)`,
          display: "flex", alignItems: "center", justifyContent: "center",
          fontSize: 24, fontWeight: 800, color: "#fff",
        }}>C</div>

        <h1 style={{ fontSize: 22, fontWeight: 700, color: C.text, margin: "0 0 6px", letterSpacing: "-0.02em" }}>
          Cortex
        </h1>
        <p style={{ fontSize: 13, color: C.subtle, margin: "0 0 28px", lineHeight: 1.5 }}>
          Sign in with your <strong style={{ color: C.muted }}>{ALLOWED_DOMAINS_LABEL}</strong> account to continue.
        </p>

        <button
          onClick={signIn}
          style={{
            width: "100%", display: "flex", alignItems: "center", justifyContent: "center", gap: 10,
            padding: "11px 16px", borderRadius: 9, cursor: "pointer",
            background: "#fff", color: "#1f2328", border: "none",
            fontSize: 14, fontWeight: 600, fontFamily: "inherit", transition: "opacity 0.15s",
          }}
          onMouseEnter={e => (e.currentTarget.style.opacity = "0.9")}
          onMouseLeave={e => (e.currentTarget.style.opacity = "1")}
        >
          <GoogleG /> Sign in with Google
        </button>

        {error && (
          <div style={{
            marginTop: 18, padding: "10px 12px", borderRadius: 8, fontSize: 12,
            color: C.error, background: C.errorBg, border: `1px solid ${C.errorBorder}`,
          }}>
            {error}
          </div>
        )}
      </div>
    </div>
  );
};
